import { useMemo } from 'react';
import FilterListItem from 'components/List/components/FilterListItem';
import useGA4Tracking from 'modules/tracking/GA4/GA4Tracking';
import useFilters from '../../../shared/hooks/useFilters';
import type { BooleanFilterOptionProps } from '../shared/types';

export default function BooleanFilterOption({
    model: { displayName, hitCount, isDisabled, value },
    queryStringName,
    menuDisplayName
}: BooleanFilterOptionProps) {
    const ga4Tracking = useGA4Tracking();
    const { togglePendingFilterByValue, isPendingFilterValueActive } = useFilters();

    const isSelected = isPendingFilterValueActive(queryStringName, value);

    // memoization pattern to avoid recreating jsx frequently
    const memoizedJSX = useMemo(
        () => (
            <FilterListItem.Button
                type="multi select"
                isSelected={isSelected}
                count={hitCount}
                buttonProps={{
                    onClick: () => {
                        togglePendingFilterByValue(queryStringName, value);
                        ga4Tracking({
                            eventName: 'select_filter',
                            category: 'ecommerce',
                            eventParams: [
                                { param_name: 'list_name', param_value: displayName },
                                { param_name: 'filter_name', param_value: value },
                                { param_name: 'filter_list_name', param_value: menuDisplayName }
                            ]
                        });
                    }
                }}
            >
                {displayName}
            </FilterListItem.Button>
        ),
        [displayName, queryStringName, value, isSelected, hitCount, menuDisplayName]
    );

    if (isDisabled) return null;

    return memoizedJSX;
}
